import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import banner_1 from "../../../assets/images/banner_1.jpg";
import BannerSlide from "./BannerSlide";
import { _t } from "../../Common/components/InjectIntlContext";

export type mainBannerSliderProps = {};
const bannerSlides = (_t: any) => [
  {
    backgroundImg: banner_1,
    title: _t("slide_1_title"),
    subtitle: _t("slide_1_text"),
    btnLabel: _t("get_started"),
  },
  // {
  //   backgroundImg: banner_2,
  //   title: _t("slide_2_title"),
  //   subtitle: _t("slide_2_text"),
  //   btnLabel: _t("get_started"),
  //   onClick: () => onGetStarted(),
  // },
  // {
  //   backgroundImg: banner_3,
  //   title: _t("slide_3_title"),
  //   subtitle: _t("slide_3_text"),
  //   btnLabel: _t("get_started"),
  //   onClick: () => onGetStarted(),
  // },
];

const slickSettings = {
  dots: true,
  infinite: true,
  arrows: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 8000,
  fade: true,
};

const MainBannerSlider: React.FC<mainBannerSliderProps> = () => {
  const slide = (slide, idx) => <BannerSlide info={slide} key={idx + "bs"} />;
  return (
    <div className="main-banner">
      <Slider {...slickSettings}>{bannerSlides(_t).map(slide)}</Slider>
    </div>
  );
};

export default MainBannerSlider;
